import "./App.css";
import React from "react";
import Viewer from "./components/Viewer";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faAngleUp,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faCircle,
  faCog,
  faDatabase,
  faExpand,
  faHouse,
  faInfo,
  faInfoCircle,
  faLeftLong,
  faListUl,
  faRightLong,
  faSpinner,
  faTimes,
  faToggleOff,
  faToggleOn,
  faArrowUpRightFromSquare,
  faSquareArrowUpRight,
} from "@fortawesome/free-solid-svg-icons";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Homepage from "./components/Homepage";
import Tutorial from "./components/Homepage/Tutorial";

library.add(faTimes); // Panel
library.add(faSpinner); // Spinner Cytoscape

library.add(faListUl); // Toolbar List
library.add(faInfoCircle); // Toolbar Info
library.add(faCog); // Toolbar Dummy_Config
library.add(faDatabase); // Toolbar Index
library.add(faExpand); // Toolbar Fullscreen

library.add(faAngleDown); // DownArrow for Dropdown menu

library.add(faCircle); // Circle for Infoview
library.add(faToggleOn); // Toggle to open List db view
library.add(faAngleUp); // Toggle to open List db view
library.add(faToggleOff); // Toggle to close List db view

library.add(faLeftLong); // Toggle to close List db view
library.add(faRightLong); // Toggle to close List db view

library.add(faInfo); // Toggle to close List db view
library.add(faHouse); // Toggle to close List db view
library.add(faArrowAltCircleLeft); // Toggle to close List db view
library.add(faArrowAltCircleRight); // Toggle to close List db view

library.add(faArrowUpRightFromSquare);
library.add(faSquareArrowUpRight);

const App = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path={"/session/:sessionId"} element={<Viewer />} />
        <Route path={"/tutorial"} element={<Tutorial />} />
        <Route path={"/"} exact={true} element={<Homepage />} />
      </Routes>
    </Router>
  );
};

export default App;
